var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.4,
    transform: "rotate(-180 12.5 12.5)",
    fill: "white",
    stroke: "#707070",
    strokeWidth: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2578 12.5002L11.2113 8.2834C10.9296 7.99016 10.9296 7.51347 11.2113 7.22015C11.4927 6.92662 11.9502 6.92662 12.2316 7.22015L16.7885 11.9684C17.0705 12.262 17.0705 12.738 16.7885 13.0316L12.2316 17.7798C11.9502 18.0734 11.4927 18.0734 11.2113 17.7798C10.9296 17.4866 10.9296 17.0098 11.2113 16.7166L15.2578 12.5002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/view-more.f7a21d43f1ab7316f46533de02ff135b.svg";
export { ForwardRef as ReactComponent };